import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export interface CashInPayload {
  store_id?: string;
  amount: number;
}

export interface CashOutPayload {
  store_id?: string;
  denominations: Record<string, number>;
  note?: string;
}

export const createCashIn = async (
  payload: CashInPayload,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/cash-in", payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create cash in.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const createCashOut = async (
  payload: CashOutPayload,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/cash-out", payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create cash out.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const getCashIns = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  store_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/cash-in", { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load cash ins.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const getCashOuts = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  store_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/cash-out", { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load cash outs.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const getCashStatus = async (params?: {
  store_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/cash/status", { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to get cash status.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
